<template>
  <div
    :class="`SisrLoader d-flex flex-column justify-content-center align-items-center ${
      color ? color : 'text-primary'
    }`"
  >
    <strong v-if="label">{{ label }}</strong>
    <div
      v-if="loaderSize === 'small'"
      class="spinner-border spinner-border-sm"
      role="status"
    />
    <div
      v-if="loaderSize === 'default'"
      :class="`spinner-border ${label ? 'm-3' : 'm-5'}`"
      role="status"
    />
  </div>
</template>

<script>
export default {
  props: {
    loaderSize: {
      type: String,
      default: "default",
    },
    color: {
      type: String,
      default: "text-primary",
    },
    label: {
      type: String,
      default: null,
    },
  },
};
</script>
